import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import HomeFAQ from './components/HomeFAQ';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '害羞草完全指南',
    url: 'https://www.mimosa-guide.com/',
    description: '害羞草（含羞草）叶片一触即合，是自然界最奇妙的感应植物之一。详解害羞草的生长习性、种植方法、养护技巧及科学原理。',
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '害羞草指南',
    url: 'https://www.mimosa-guide.com/',
    description: '专注于害羞草（含羞草）种植养护知识的中文科普平台',
  };

  return (
    <>
      <SEOHead
        title="首页"
        description="害羞草（含羞草）叶片一触即合，是自然界最奇妙的感应植物之一。详解害羞草的生长习性、种植方法、养护技巧及科学原理，帮助你轻松在家种出这株神奇植物。"
        canonicalUrl="https://www.mimosa-guide.com/"
      />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <HomeFAQ />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}